import * as Bowser from 'bowser';

const browser = Bowser.getParser(window.navigator.userAgent);

const { name: browserName } = browser.getBrowser();
// browser name aliases can be found here
// @see https://github.com/lancedikson/bowser/blob/master/src/constants.js
const isValidVersion = browser.satisfies({
  chrome: `>=${process.env.REACT_APP_CHROME_VALID_VERSION}`,
  edge: `>=${process.env.REACT_APP_EDGE_VALID_VERSION}`,
});

const isChromium = browserName === 'Chromium';
const isChrome = browserName === 'Chrome';
const isSafari = browserName === 'Safari';
const isIE = browserName === 'Internet Explorer';
const isEdge = browserName === 'Microsoft Edge';
const isFirefox = browserName === 'Firefox';
const isOpera = browserName === 'Opera';
const isMobile = browser.getPlatformType(true) === 'mobile';
const isIPad = !!window.navigator.platform && /iPad/.test(window.navigator.platform);

const isValidBrowser = isFirefox || isChromium || ((isChrome || isEdge) && isValidVersion);

export {
  browserName,
  isValidVersion,
  isChrome,
  isSafari,
  isIE,
  isEdge,
  isFirefox,
  isOpera,
  isValidBrowser,
  isMobile,
  isIPad,
};
